module.exports = __webpack_public_path__ + "static/img/2-nei.ce04503.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/2-nei.png
// module id = aWq6
// module chunks = 1